import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const LocationAutocomplete = ({
  title,
  placeholder,
  responseData,
  labelKey,
  onChange,
  value,
  disabled = false,
}) => {
  return (
    <Autocomplete
      freeSolo
      disabled={disabled}
      value={value}
      onChange={(event, newValue) => onChange(newValue)} // triggered on dropdown select or pressing enter
      onInputChange={(event, inputValue) => onChange(inputValue)} // triggered on typing
      options={responseData || []}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option[labelKey] || ''
      }
      isOptionEqualToValue={(option, val) => {
        if (!val) return false;
        if (typeof val === 'string') return option[labelKey] === val;
        return option[labelKey] === val[labelKey];
      }}
      renderInput={(params) => (
        <TextField {...params} label={title} placeholder={placeholder} />
      )}
    />

  );
};

export default LocationAutocomplete;
